import { render, staticRenderFns } from "./departList.vue?vue&type=template&id=0b12d19d&scoped=true"
import script from "./departList.vue?vue&type=script&lang=js"
export * from "./departList.vue?vue&type=script&lang=js"
import style0 from "./departList.vue?vue&type=style&index=0&id=0b12d19d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b12d19d",
  null
  
)

export default component.exports